import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Perfil } from '../../shared/model/security/perfil.model';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs'; // agrege JMH
import { FetchResult } from 'src/app/shared/model/emision/FetchResult.model';
import { Menu } from 'src/app/shared/model/security/menu.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Base } from 'src/app/shared/model/core/base.model';
import { Corporativobean } from 'src/app/shared/model/security/persona.model';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { sinSelloDeError } from 'src/app/shared/http/sello-de-error';

const API_URL = environment.apiUrl;

export interface PerfilListCache {
  response: ConsultaList<Perfil>;
  currentPage: number;
  itemsPerPage: number;
}

@Injectable()
export class PerfilService {

private idperfil = new BehaviorSubject<number>(0);
cast = this.idperfil.asObservable();
private perfilesCache: PerfilListCache | null = null;
  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) { }

  editidCliente(newCliente) { 
    this.idperfil.next(newCliente); 
       }

  consultarPerfiles(): Observable<Perfil[]> {
    return this.http.get<Perfil[]>(API_URL + 'controller/null.do', { });
  }

  //--- NUEVOS METODOS 
  consultarPerfil(bean: ConsultaList<Perfil>) {
    return this.http.post<ConsultaList<Perfil>>(API_URL + 'controller/buscaPerfilesPaginacion.do', bean, { }); // Consulta gestion de perfiles con paginacion
  }
  setPerfilesCache(data: PerfilListCache | null): void {
    this.perfilesCache = data;
  }
  getPerfilesCache(): PerfilListCache | null {
    return this.perfilesCache;
  }
  ConsultaSitios(){
    return this.http.get(API_URL + 'controller/buscasitiosPerfil.do',{ }); // para el puro sitio
  }
  ConsultaMenus(nombre: String){
    return this.http.post<Menu[]>(API_URL + 'controller/buscaMenuss.do', nombre, { }); // para los puros menus por el sitio seleccionado
  }
  // El servidor rechaza con HTTP 200 y COD_STATUS=ERROR en los headers
  // (sin la hoja de Perfiles, un menu que el editor no ofrece, el perfil de
  // plataforma): sin el operador, la pantalla decia "Se modificó
  // correctamente" aunque no se hubiera guardado nada.
  GuardaPerfil(perfil: Perfil): Observable<any> {
    return this.http
      .post(API_URL + 'controller/guardaOrModificaPerf.do', perfil, { observe: 'response' })
      .pipe(sinSelloDeError('No se pudo guardar el perfil.'));
  }
  ConsulXUpdatePerfil(beanperfil: Perfil): Observable<any> {
    return this.http.post<ConsultaList<Perfil>>(API_URL + 'controller/consultaUnSoloPerfilUpdate.do', beanperfil, { }); // consulta un solo perfil a modificar 
  }
  ConsulXUpdateMenu(id: Number): Observable<any> {
    return this.http.post<Perfil[]>(API_URL + 'controller/consultaMenusIdPerfil.do', id, { }); /// para los puros menus
  }

  InsertaCorporativo(corpo: Corporativobean) {
    console.log('SERVICE:::: ENVIARA BEAN DE CORPORATIVO::: ', corpo)
    return this.http.post<Base>(API_URL + 'controller/pruebaS.do', corpo,  { }); // para Guradar el perfil
      }

    /*  InsertaCorporativo(corpo: Corporativobean) {
        console.log('SERVICE:::: ENVIARA BEAN DE CORPORATIVO::: ', corpo)
        return this.http.post<Base>(UrlConstantes.insertacorpor, corpo);
      }*/
}
